exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../node_modules/css-loader/dist/cjs.js!normalize.css/normalize.css"), "");

// Module
exports.push([module.id, ".progress{transform:rotate(-90deg)}.progress .progress-circle,.progress .progress-value{fill:transparent}.progress .progress-circle{stroke:#f5f5f5}.progress .progress-value{stroke:#EB6400;stroke-linecap:round}.determinate .progress-value{transition:stroke-dashoffset 1s ease}.indeterminate .progress{animation:rotate 1s linear infinite}@keyframes rotate{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}\n", ""]);

